import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import {isUndefined} from "lodash";
import React from "react";
import {PaymentPlanFrequency} from "../../../../enums";
import {prettifyCurrency, subtract} from "../../../../helpers";
import {Colors, Container, Divider} from "../../../../ui";
import {ICustomizedInstallment} from "../../../declarations";
import {mapFrequencyToTitle} from "../utils";
import {SummaryText} from "../utils-components";

dayjs.extend(utc);
dayjs.extend(timezone);

interface IInstallmentsSummaryDetails {
  last_4_digits?: string;
  payment_method_type?: string;
  discount?: number;
  endDate?: string;
  totalBalance?: number;
  totalPlanAmount: number;
  frequency: PaymentPlanFrequency;
  installmentSize: number;
  lastPayment: number;
  numOfInstallments: number;
  customInstallment?: ICustomizedInstallment;
  lateFees?: number;
}

const InstallmentsSummaryDetails = ({
  last_4_digits,
  payment_method_type,
  discount,
  lastPayment,
  numOfInstallments,
  totalBalance,
  totalPlanAmount,
  frequency,
  installmentSize,
  lateFees,
}: IInstallmentsSummaryDetails) => {
  const isCustomPlan = frequency === "non_linear";
  const amountDeducted = subtract(totalBalance || 0, totalPlanAmount);
  return (
    <Container fullWidth sx={{gap: "3px"}}>
      {last_4_digits && payment_method_type && (
        <SummaryText field={payment_method_type === "ach" ? "ACH" : "Card"} value={last_4_digits} />
      )}
      {!isUndefined(discount) && discount > 0 && <SummaryText field={"Discount"} value={`${discount * 100}%`} />}
      {amountDeducted > 0 && totalBalance && (
        <SummaryText field={"Total balance due"} value={prettifyCurrency(totalBalance)} lineCross />
      )}
      <SummaryText field={"Chosen plan amount"} value={prettifyCurrency(totalPlanAmount)} />
      {amountDeducted > 0 && totalBalance && (
        <SummaryText field={"Amount deducted"} value={prettifyCurrency(totalBalance - totalPlanAmount)} />
      )}
      <Divider sx={{width: "100%", height: "2px", borderColor: Colors.grey._100, margin: "5px 0px"}} />
      {!!lateFees && <SummaryText field={"Late fees"} value={prettifyCurrency(lateFees)} />}
      <SummaryText
        field={"Installments"}
        value={
          !isCustomPlan && installmentSize
            ? `${String(numOfInstallments)} X ${prettifyCurrency(installmentSize)}`
            : "Custom"
        }
      />
      {!!lastPayment && !isCustomPlan && (
        <SummaryText field={"Last installment"} value={prettifyCurrency(lastPayment)} />
      )}
      <SummaryText field={"Frequency"} value={isCustomPlan ? "Custom" : mapFrequencyToTitle[frequency].title} />
    </Container>
  );
};

export default InstallmentsSummaryDetails;
